import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useContent } from "@/lib/hooks";
import PageHeader from "@/components/PageHeader";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t, ml } = useLang();
  const { data: faqs = [], isLoading } = useContent("/content/faqs");

  return (
    <div data-testid="faq-page">
      <PageHeader title={t("faq.title")} subtitle={t("faq.subtitle")} testId="faq-title" />
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        {isLoading ? (
          <p className="text-zinc-500">{t("common.loading")}</p>
        ) : (
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((faq, idx) => (
              <AccordionItem
                key={faq.id}
                value={faq.id}
                className="rounded-xl border border-zinc-200 bg-white px-6 data-[state=open]:border-[#0D9488]"
              >
                <AccordionTrigger data-testid={`faq-question-${idx}`} className="text-start font-heading text-base font-bold text-zinc-950 hover:no-underline">
                  {ml(faq.question)}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-zinc-600">
                  {ml(faq.answer)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        )}

        <div className="mt-16 rounded-2xl bg-[#062B2B] p-9 text-center">
          <h2 className="font-heading text-xl font-bold text-white md:text-2xl">{t("faq.moreTitle")}</h2>
          <p className="mt-2 text-sm text-zinc-400">{t("faq.moreText")}</p>
          <Link
            to="/iletisim"
            data-testid="faq-contact-cta"
            className="mt-6 inline-flex items-center gap-2 rounded-lg bg-[#0D9488] px-6 py-3 text-sm font-bold text-white transition-colors duration-200 hover:bg-[#0F766E]"
          >
            {t("faq.moreCta")}
            <ArrowRight className="h-4 w-4 rtl:rotate-180" />
          </Link>
        </div>
      </div>
    </div>
  );
}
